const roomsSuitesFunctions = () => {
    if ( $('.rooms-suites__filter-outer').length ) {        
        ScrollTrigger.create({
            trigger: '.rooms-suites__filter-outer',
            start: () => {
                const headerHeight = $('.c-header__logo-row').outerHeight();
                return 'top top+=' + headerHeight;
            },
            endTrigger: '.rooms-suites',
            end: 'bottom bottom',
            pin: true,
            pinSpacing: false
        });
    }

    $(document).on('click', '.js-amenities-toggle', function(e) {
        e.preventDefault();

        const amenitiesElem = $(this).closest('.rooms-suites__amenities-container').find('.rooms-suites__amenities-list');

        $(this).stop().toggleClass('open');
        $(amenitiesElem).stop().slideToggle(800);
    });
}